<template>
  <info-section-card :fields="fields" :data="data">
    <template v-slot:header>
      <h4 class="blue-text">{{L10n('po')}}</h4>
    </template>
  </info-section-card>
</template>

<script>
export default {
  name: 'InfoSectionPO',
  components: {
    'info-section-card': () => import(/* webpackChunkName: 'InfoSection' */ '@/components/InfoSection/Card.vue')
  },
  props: {
    data: { type: Object }
  },
  data () {
    return {
      fields: [
        { title: this.L10n('po'), fieldName: 'po', classes: 'info-section__label' },
        { title: this.L10n('po-date'), fieldName: 'poDate', filter: 'toDate' },
        { title: this.L10n('requested-date'), fieldName: 'requestedDate', filter: 'toDate' },
        { title: this.L10n('order-rating-score'), fieldName: 'orderRatingScoreText' },
        { title: this.L10n('payment-term'), fieldName: 'paymentTermTitle' },
        { title: this.L10n('ship'), fieldName: 'shipToCompanyName' },
        { title: this.L10n('ship-detail'), fieldName: 'shipToCompanyDetail' },
        { title: this.L10n('ship-contact'), fieldName: 'shipToContactName' },
        { title: this.L10n('forwarder'), fieldName: 'customerForwarderName' }
      ]
    }
  }
}
</script>
